name: Sex & Relationships
slug: sex-and-relationships
cards:
  - question: If you could go back to your 21st birthday, you would choose to…
    answers:
      - go out more
      - lose your virginity
      - slow down
      - change nothing
  - question: Of the following household guests, which would you be most upset to see in your living room?
    answers:
      - Your ex
      - Your parents
      - Your partner’s ex
      - Your sibling
  - question: If your child announced their intention to become one of the following, which would bother you the least?
    answers:
      - Exotic dancer
      - Sex therapist
      - Bikini waxer
      - Solo adult performer
  - question: One of the following people must speak at your funeral. Who would you most prefer?
    answers:
      - A professional rival
      - An ex-lover
      - An estranged family member
      - Your former therapist
  - question: If you were known around town, you’d prefer to be known as…
    answers:
      - An exceptional lover
      - A pillar of the community
      - A shrewd risk-taker
      - A dutiful spouse
  - question: You have the opportunity to become certified as one of the following. Which would you choose?
    answers:
      - Chiropractor
      - Dance instructor
      - Personal trainer
      - Sex therapist
  - question: Which of the following would you prefer to install in your home?
    answers:
      - A hot tub
      - A sex swing
      - An exercise machine
      - Hidden cameras
  - question: Some people are open with their sex lives, some less so. Where do you fall?
    answers:
      - I’m an open book.
      - I’ll share, in the right company.
      - That’s my private business.
  - question: You can go through a safe, cosmetic surgery that will cost $5,000 and permanently change a part of yourself you dislike. You would…
    answers:
      - Have the surgery
      - Postpone the surgery for a year
      - Go on a $5,000 vacation
      - Invest the $5,000
  - question: When with your best friends, you spend more time discussing…
    answers:
      - Your sex life
      - Their sex lives
      - Your partner
      - Their partners
  - question: If you were going out for the first time with someone you found attractive, you would wear...
    answers:
      - What I normally wear
      - A conservative outfit
      - Something new
      - Something conducive to being removed later
  - question: A charity event is taking bids — one lucky attendee will spend a private evening with a gorgeous, successful celebrity. How much would you bid for the opportunity?
    answers:
      - $100 or less
      - Between $100 and $1,000
      - Between $1,000 and $10,000
      - $10,000 or more
  - question: You’re on a weeklong camping trip with old friends, split evenly by gender, one of whom is a longstanding crush. It’s discovered that there’s a shortage of equipment. Who will you try to share a tent with?
    answers:
      - A friend of the ‘safe’ gender
      - A friend of the gender you generally find attractive
      - Your crush
      - It doesn’t matter
  - question: Over the course of a year, how much pornography do you consume?
    answers:
      - As much as I can find
      - Enough to take the edge off
      - I don’t know
      - None
  - question: Who do you consider more of a role model?
    answers:
      - Sally Hemings
      - Marilyn Monroe
      - Monica Lewinsky
      - Stormy Daniels
  - question: Which would you rather have tattooed on your body?
    answers:
      - Your partner’s name
      - Your parent’s name
      - Your own name
      - Your child’s name
  - question: In a dark nightclub, your attractive dance partner, whom you’ve only met tonight, starts putting their hands all over you. What do you do?
    answers:
      - Find someone else to dance with
      - Gently remove their hands but keep dancing
      - Teach them a lesson
      - Reciprocate
  - question: At a pool party, two women start fighting in the water. What do you do?
    answers:
      - Nothing/watch
      - Tell them to stop
      - Physically separate them
      - Walk away
  - question: After a few drinks, you tend to…
    answers:
      - Fall asleep
      - Get horny
      - Laugh a lot
      - Get loud
  - question: If you knew there would be no consequences, who would you most want to sleep with?
    answers:
      - An ex-lover
      - An old friend
      - Someone in my partner’s family
      - Someone in my family
  - question: When would you say you first had sex?
    answers:
      - As a teenager
      - In your 20s
      - In your 30s
      - I still haven’t
  - question: If your friends candidly assessed your physical attractiveness, they’d say you were…
    answers:
      - Below average
      - Average
      - Above average
  - question: I usually deal with problems in my relationship by…
    answers:
      - Ignoring them
      - Blaming myself
      - Blaming the other person
      - Discussing them openly
  - question: You find out from a reliable source that a decade ago, a good friend slept with your partner at the time. What are you most likely to do?
    answers:
      - Cut the friend out of your life
      - Snub them until they ask what’s wrong
      - Pretend you never found out
      - Bring it up with them and laugh about it
  - question: Given similar annual earnings, which would you rather be?
    answers:
      - Bodybuilder
      - Backup dancer
      - Businessperson
      - TV presenter
  - question: Given similar annual earnings, which would you rather be?
    answers:
      - Physical therapist
      - Masseuse
      - Stripper
      - Private escort
  - question: Which of the following is most pleasurable?
    answers:
      - A massage
      - A glass of wine
      - Sleep
      - Sex
  - question: Which of the following best describes your long-term relationships?
    answers:
      - Power
      - Peace
      - Sensuality
      - Ambition
  - question: How would you describe your temperament in bed?
    answers:
      - Gentle
      - Wild
      - Romantic
      - Energetic
  - question: Which of the following qualities do you most look for in a romantic partner?
    answers:
      - Determination
      - Honesty
      - Intelligence
      - Kindness
  - question: When are you least in the mood for sex?
    answers:
      - After an argument
      - After a big meal
      - After a long day
      - After a personal setback
  - question: At this point in your life, which of the following would most improve your sex life?
    answers:
      - A different partner
      - A different location
      - Letting go of your inhibitions/insecurities
      - Spending time with your partner
  - question: My attitudes towards sex and nudity are most similar to…
    answers:
      - My mother
      - My father
      - My best friend
      - My local religious leader
  - question: How familiar are you with the Kama Sutra?
    answers:
      - Very
      - Somewhat
      - Not at all
  - question: If you could modify one of the following aspects of your body, which would you choose?
    answers:
      - Your height
      - Your weight
      - Your agility
      - Your body symmetry
  - question: If you spot an attractive stranger at the mall, what are you most likely to do?
    answers:
      - Nothing
      - Tell my friend/partner
      - Follow them
      - Strike up conversation
  - question: Which of the following acts, if you were seen by your partner, would you find most embarrassing?
    answers:
      - Masturbating
      - Showering
      - Using the toilet
      - Grooming your genitals
  - question: My first sexual experience was...
    answers:
      - Unpleasant
      - Forgettable
      - Awkward
      - Amazing
  - question: If you had to choose the country in which your lover was raised, you would choose...
    answers:
      - Iran
      - South Africa
      - Denmark
      - Peru
  - question: For you, the distance between pain and pleasure is...
    answers:
      - small
      - collapsible, given the right context
      - uncrossable
  - question: Which of the following names is most objectionable to you, in the context of lovemaking?
    answers:
      - mommy/daddy
      - slave
      - soulmate
      - whore/gigolo
  - question: Which of the following sexual situations most appeals to you?
    answers:
      - a threesome
      - having sex in the same room as another couple
      - getting caught by someone you know
      - being watched
  - question: Which of the following would you choose to have with you if imprisoned in solitary confinement?
    answers:
      - Madame Bovary by Gustave Flaubert
      - Delta of Venus by Anaïs Nin
      - Fifty Shades of Grey by E L James
      - An issue of Sports Illustrated
  - question: A friendly older couple approach you at a party and strike up conversation. Later, they invite you over for a nightcap. What are you most likely to do?
    answers:
      - Make up an excuse to get away from them
      - Politely decline
      - Suggest meeting for dinner in the future instead
      - Accept the offer
  - question: A houseguest (who you've never met before) is staying overnight. Which circumstance would bother you the most?
    answers:
      - They repeatedly compliment your spouse about their body
      - They walk naked from the bathroom to the guest bedroom
      - They insist on taking pictures while you're in your sleepwear
      - In the morning, they joke about hearing your lovemaking
  - question: On a scale of promiscuity, I consider myself...
    answers:
      - 0 to 4 (relatively chaste)
      - 5 to 7 (normal)
      - 8 to 10 (relatively promiscuous)
  - question: Regarding flirting, my friends would say that...
    answers:
      - I flirt with everyone
      - I don't know when to stop
      - I'm hopeless/oblivious
      - I'm an expert
  - question: I tell dirty jokes most frequently around...
    answers:
      - my partner
      - my friends
      - my colleagues
      - my family
  - question: Your most recent sexual dream primarily featured...
    answers:
      - your partner
      - a stranger
      - friends or family
      - none of the above, or something you can't remember
  - question: Which location would you prefer for a romantic getaway?
    answers:
      - A ski resort
      - A downtown penthouse suite
      - A beachhouse
      - A casino hotel room
  - question: Which do you find most sexually stimulating?
    answers:
      - Adult movies
      - Romance novels
      - Social media feeds
      - Your imagination
  - question: When it comes to sexual attitudes and appetite, you and your partner...
    answers:
      - are usually in sync
      - find a middle ground that works
      - are total opposites
  - question: Which of the following would most boost your ego?
    answers:
      - Satisfying multiple sexual partners
      - Receiving compliments from your significant other
      - Being ogled by your coworkers
      - Being more successful than your ex-lovers
  - question: You're flying first-class from London to Sydney. Your seatmate is friendly and unusually attractive. What would you consider the most favorable outcome?
    answers:
      - Enjoying pleasant conversation
      - Exchanging contact information
      - Discovering you share a mutual friend
      - A 'quickie' in the airplane bathroom
  - question: Which version of the afterlife would most appeal to you?
    answers:
      - Being restored to 35 years old
      - Finding everyone you knew to be willing sexual partners
      - Being able to watch those still alive
      - Eternal slumber
  - question: Which of the following 'Secret Santa' gifts would you find most embarrassing?
    answers:
      - A sex toy
      - A revealing swimsuit
      - A love letter
      - A painting of you, as if reclining in bed
  - question: Which quality is the biggest turnoff for you?
    answers:
      - Smoking
      - Drinking to excess
      - Being careless with money
      - Being loud and obnoxious in conversation
  - question: You've initiated a sexual encounter. Who should climax first?
    answers:
      - You
      - Your partner
      - Either person
      - Who said anything about a climax?
  - question: Walking home, you spot a middle-aged woman standing on the sidewalk, completely naked. What is your likely reaction?
    answers:
      - Cross the street
      - Ask her if she needs help
      - Call the police
      - Film her with your phone
  - question: Walking home, you spot a middle-aged man standing on the sidewalk, completely naked. What is your likely reaction?
    answers:
      - Cross the street
      - Ask him if he needs help
      - Call the police
      - Film him with your phone
  - question: Which music genre, if playing in the background, would make it hardest for you to feel sexy?
    answers:
      - Rap
      - Gospel
      - Classical
      - Heavy metal
  - question: We're probably all guilty of fantasizing about someone we shouldn't. Which amount best approximates what you would pay to turn your fantasy into reality?
    answers:
      - $20
      - $200
      - $2,000
      - $20,000
  - question: Prostitution should be...
    answers:
      - A normal job, supported by health officials
      - Legal but discouraged
      - Illegal but tolerated
      - Criminally prosecuted
  - question: While on a business trip, you and a close colleague get drunk and become intimate. While enjoyable, you both agree it was an isolated indiscretion. On returning home, how would you report the trip to your partner?
    answers:
      - Confess, and ask forgiveness
      - Admit to drinking too much, and omit the rest
      - Pretend it was a normal business trip
      - Avoid the subject
  - question: At what age should parents have the 'birds and bees' talk with their children?
    answers:
      - Before puberty
      - As a teenager
      - When they get into their first serious relationship
      - Never
  - question: If you had to change one thing about your partner, what would it be?
    answers:
      - Their attitude towards money
      - Their attitude towards children
      - Their education
      - Their appearance
  - question: According to psychologists, our sexual tastes are influenced by many factors. Which of the following do you think has most shaped your sexual tastes?
    answers:
      - Religion
      - Your partners
      - Pop culture
      - Pornography
  - question: If you had to appear on stage wearing nothing except one of the following, which would you grab?
    answers:
      - a feather boa
      - a sombrero
      - boots
      - jewelry
  - question: You're potentially one question away from winning this game. In which of the following areas should the next question focus to maximize your chances?
    answers:
      - Our work lives
      - Our love lives
      - Our tastes in popular culture
      - Our political opinions
  - question: You've found some free workshops being offered tonight around the city. Which of the following are you most likely to attend?
    answers:
      - Rekindling the Fire
      - Breaking Free of Gender Roles
      - Introduction to Polyamory
      - Understanding Your Body
  - question: One day, you learn your partner's best friend finds you attractive. What are you most likely to do?
    answers:
      - Text them more frequently
      - Try to have an affair
      - Nothing
      - Tell your partner, and try to arrange a threesome
  - question: You leave your partner of 25 years after discovering that they have been unfaithful. What's the minimum amount of time that would have to pass before you would consider another serious relationship?
    answers:
      - None
      - About a year
      - A few years
      - I would never consider another serious relationship
  - question: What do you consider the least harmful of the following for your 16-year-old niece/nephew to accidentally see?
    answers:
      - You, taking a shower
      - Internet pornography
      - An 'R'-rated movie
      - Their friends, smoking marijuana
  - question: Washing up in the office restroom, you accidentally splash water all over your crotch. What do you do?
    answers:
      - Wait 30 minutes in a stall until you're dry
      - Sneak out and go home early
      - Go back to your desk and explain what happened
      - Ask a trusted colleague if they have a change of clothes
  - question: A good friend is giving a speech at their birthday party. What would make you most likely to interrupt them?
    answers:
      - You can see their underwear
      - They're drunk, and saying things they might regret
      - You just saw their spouse in a compromising position with someone else
  - question: Which of the following do you think would most improve your sex life?
    answers:
      - Hitting the gym
      - Taking a cooking class
      - Helping out with chores/the kids
      - Dressing differently
  - question: Your company is relocating you to a new city for five years. Which location will provide the best social life for you?
    answers:
      - New York
      - Cairo
      - Caracas
      - Johannesburg
  - question: The goal of having sex is primarily to...
    answers:
      - orgasm
      - have fun
      - connect with my partner
      - get pregnant
  - question: At what time of day are you usually most aroused?
    answers:
      - When I wake up
      - Around noon
      - Around sunset
      - Before going to bed
  - question: I consider people who are transgender to be...
    answers:
      - brave
      - like anyone else
      - confused
      - mentally ill
  - question: Which of the following meals would you prefer to eat on a first date?
    answers:
      - Oysters
      - Chili
      - Curry
      - Milkshake
  - question: Tantric sex is...
    answers:
      - nonsense
      - for other people
      - something to try at least once
      - the path to bliss
  - question: Which sport produces the most attractive athletes, in general?
    answers:
      - Tennis
      - Figure skating
      - Swimming
      - Marathon
  - question: Which sport produces the most attractive athletes, in general?
    answers:
      - Formula 1 racing
      - Snowboarding
      - Gymnastics
      - Decathlon
  - question: To you, the most attractive male physique is...
    answers:
      - like a big bear
      - trim
      - muscular
      - well-endowed
  - question: To you, the most attractive female physique is...
    answers:
      - slender
      - full and curvy
      - muscular
      - small
  - question: A fulfilling sex life can best be found by...
    answers:
      - focusing on the other person
      - learning about your own body
      - exploring many partners
      - communicating with your partner outside the bedroom
  - question: At a festival, you have your palm read. Which of the following predictions would you find least likely to occur within the next two years?
    answers:
      - You will juggle two lovers
      - You will have an affair
      - You will be married
      - You will be divorced
  - question: You are caught in a minor scandal. Which circumstance do you consider most likely to be the cause?
    answers:
      - You are arrested for public indecency
      - Someone you know finds home video of you on an adult website
      - A colleague sees something inappropriate for work on your computer
      - Your family discovers one of your sexual kinks
  - question: If you could spend a single night with one of the following, who would you choose?
    answers:
      - A current colleague
      - Someone from your neighborhood
      - Your next online dating match
      - One of your in-laws
  - question: At an after-hours social, you find the phone of an attractive colleague who has already left. It's unlocked. What are you most likely to do?
    answers:
      - Leave it there
      - Put it in your locker so you can return it the following day
      - Look through their photo library
      - Take it home so you can browse their photos, messages, emails and copy anything interesting
  - question: How often do you masturbate?
    answers:
      - Infrequently
      - About once a week
      - Daily
      - Constantly
  - question: In the last year, with how many people have you sent or received intimate photographs?
    answers:
      - None
      - One
      - Two or three
      - Many
  - question: How often are you currently having sex?
    answers:
      - Infrequently
      - About once a week
      - Daily
      - Constantly
  - question: You stumble across the journal of someone you know, and find yourself mentioned in their sexual fantasies. Whose journal is it most likely to be?
    answers:
      - Your cousin
      - Your best friend
      - Your best friend's spouse
      - Your professor/student
  - question: Which of the following substances are you most likely to use to enhance a sexual experience?
    answers:
      - Alcohol
      - Marijuana
      - Ecstasy
      - Chocolate
  - question: I would be most likely to stay away from someone who...
    answers:
      - is interested in people far outside their own age
      - is addicted to pornography
      - hosts orgies
      - is only aroused by watching others
  - question: To avoid being fired, a sick friend needs you to show up for their job tomorrow. Despite detailed instructions, which job would make you most anxious?
    answers:
      - Nightclub bouncer
      - Tanning salon associate
      - Bra fitter
      - Locker room attendant
  - question: Preparing to leave a dinner party, you spot two guests getting intimate in the room with everyone's coats. They haven't seen you. What do you do?
    answers:
      - Rejoin the party and check again later
      - Tell the host
      - Knock politely on the door, wait a moment and then enter the room
      - Walk in and get your coat, pretending not to see them
  - question: Late at night, you and your friends have to shelter from the rain in one of the following establishments. Which do you vote for?
    answers:
      - the strip club
      - the tattoo shop
      - the underground bar
      - the Thai massage parlor
  - question: A good friend has a car accident that leaves them partially paralysed. Months later, while visiting them at home, they confess that their injuries prevent them from relieving their sexual frustration. What would you most likely do?
    answers:
      - Express sympathy with their problem
      - Suggest hiring a 'special' homecare professional
      - Make a few jokes
      - Relieve their frustration yourself
  - question: You and your partner are on vacation at an island resort. Where are you least likely to get frisky?
    answers:
      - In the pool
      - On your room balcony
      - Against your room window
      - In the sea
  - question: When it comes to a partner's body hair...
    answers:
      - I don't care, as long as they're hygienic
      - I prefer a natural look
      - I prefer less hair
      - I find all body hair disgusting
  - question: When it comes to oral sex...
    answers:
      - I prefer to give than to receive
      - I prefer to receive than to give
      - I have little interest in it
      - anything goes
  - question: In 2020, an airborne virus swept the world, killing millions and confining families to their homes for long periods. In such a situation, what is the least appropriate way to satisfy your sexual needs?
    answers:
      - Eavesdropping on other family members
      - Masturbating with a married friend via a video call
      - Meeting strangers for sex
      - Visiting a crowded nightclub, while wearing a mask and maintaining a safe distance at all times
  - question: Your partner of 25 years passes away from natural causes. What's the minimum amount of time that would have to pass before you would consider another serious relationship?
    answers:
      - None
      - About a year
      - A few years
      - I would never consider another serious relationship
  - question: I would be most surprised to discover my mother had once...
    answers:
      - been a nude model for art students
      - been attracted to her close girl-friend
      - considered an abortion when pregnant with me
      - had sex while I was in the room as an infant
  - question: I consider marriage...
    answers:
      - an outdated institution
      - a sacred union
      - a legal arrangement
      - the source of much unhappiness
  - question: You have a painless but incurable ailment that will kill you in a year. What are you most likely to do?
    answers:
      - Sleep around
      - Confess your love to someone you know
      - Withdraw from society
      - Nothing different
  - question: If you had to select a sexual partner based solely on their age, you would select the person aged...
    answers:
      - 21
      - 35
      - 50
      - 65
  - question: You're attending a masquerade in the city, and the following costumes are available to rent. Which do you choose?
    answers:
      - Nurse/doctor
      - Librarian
      - Firefighter
      - Airline pilot
  - question: When meeting my child's betrothed for the first time, I would be most interested in learning about their...
    answers:
      - financial prospects
      - religious beliefs
      - family
      - relationship with my child
  - question: You have the house to yourself for the weekend. What are you most likely to do?
    answers:
      - Walk around naked
      - Invite someone over
      - Watch/read something naughty
      - Nothing unusual
  - question: While browsing your joint photo library, you see pictures of your partner skinny-dipping with friends at a recent college reunion. Which best describes your likely reaction?
    answers:
      - You are upset by their exhibitionism
      - You are hurt at not being told before or after about the event
      - You are happy to see them happy
      - You are excited by the prospect of a new activity you might both enjoy
  - question: When weighed against personality, how important is a person's physical appearance to their overall attractiveness?
    answers:
      - Appearance is more important
      - Appearance and personality both matter
      - Personality is more important
  - question: You discover that a colleague was promoted over you because they are intimately involved with a senior executive. What do you do?
    answers:
      - Nothing
      - Report the relationship to the appropriate authority
      - Tell a few trusted colleagues about it
      - Ingratiate yourself to a senior executive
  - question: I am sexually attracted to...
    answers:
      - none of my close friends
      - one or two of my close friends
      - several of my close friends
  - question: I would prefer to date people who have had...
    answers:
      - No sexual partners
      - Few sexual partners
      - Many sexual partners
      - A similar number of sexual partners as myself
  - question: If I could choose without consequence, I would spend most of my time around...
    answers:
      - Men
      - Women
      - Both men and women
  - question: After a sexual experience, which of the following comments would make you most uncomfortable?
    answers:
      - “It happens sometimes, I understand”
      - “That was amazing, I can't wait to post about it”
      - “I'm going to call my sister, do you mind?”
      - “I'll turn the camera off now”
  - question: When discussing your sex life with friends, how closely do you stick to the truth?
    answers:
      - I tell it like it happened
      - I take a bit of creative license with my stories
      - I lie to make myself look good or save face
  - question: To what extent do friends seek your advice on relationships and sex?
    answers:
      - All the time
      - Sometimes
      - Never
  - question: What's the least notice you require to feel comfortable showing up for a first date?
    answers:
      - an hour
      - a few hours
      - a day
      - a few days
  - question: You receive a selfie from an unknown number. In it, an attractive person displays their body. What do you do?
    answers:
      - Reply “Sorry, wrong number”
      - Ignore it
      - Save the picture
      - Try to get to know them
  - question: While visiting a friend for a few days, you discover that the TV in their guest bedroom is connected to their digital home video library. Some of the video titles and thumbnails seem explicitly sexual. What do you do?
    answers:
      - Nothing
      - Tell your friend right away
      - Tell your friend a week later, as an aside in a thank-you email
      - Mute the TV and watch the videos
  - question: Standing in a tight crowd, you accidentally brush against a woman's breast. What do you do?
    answers:
      - Nothing, since some body contact is unavoidable
      - Use your facial expression to apologize
      - Say you're sorry
      - Try to do it again, this time deliberately
  - question: Compared to the sexual activity of my peers, I would consider myself...
    answers:
      - relatively inactive
      - average
      - relatively active
  - question: While retrieving clean laundry from a dryer in your apartment building, you spot an odd piece of racy underwear mixed in with your things. It could belong to the person using a nearby machine. What do you do?
    answers:
      - Leave it in the dryer
      - Take it with you
      - Ask the person if it belongs to them
      - Wait until the person isn't looking, and add the item to their laundry
  - question: You agree to help a close friend celebrate their birthday by attending a cuddle party. However, during the party, some attendees initiate more sexual activities, and your friend seems willing to join. What do you do?
    answers:
      - Leave, with or without your friend
      - Discourage your friend from joining
      - Join the activities, but avoid your friend
      - Join, and go with the flow
  - question: Being 'sex-positive' parents means...
    answers:
      - encouraging your children, when appropriate, to practice safe sex
      - raising your children to be unashamed of their bodies
      - discussing sex like any other topic as a family
      - not hiding sexual activity behind closed doors
  - question: At the office Christmas party, you find yourself under the mistletoe with your attractive boss, who smiles and leans towards you. What do you do?
    answers:
      - Start talking
      - Turn or step back
      - Peck them on the cheek
      - Kiss them on the lips
  - question: Which of the following sports are you in the best shape to play tomorrow?
    answers:
      - Football
      - Cycling
      - Table tennis
      - Skeet shooting
  - question: The part of my life story most likely to impress a new date is my...
    answers:
      - financial success
      - academic/professional achievements
      - travelogue
      - sexual escapades
  - question: Staying at a motel, you hear the sounds of lovemaking through the wall. What are you most likely to do?
    answers:
      - Nothing
      - Turn on the TV
      - Use a glass between your ear and the wall to amplify the sound
      - Call the front desk and make a noise complaint
  - question: Over dinner, a couple you've known for years confesses they want to spice up their bedroom, and invite you to watch them. What do you do?
    answers:
      - Laugh it off
      - Accept the invitation
      - Sidestep the question by talking about your own sexual frustrations
      - Politely decline the invitation
  - question: Which of the following U.S. First Ladies do you find most intriguing?
    answers:
      - Jill Biden
      - Melania Trump
      - Michelle Obama
      - Hillary Clinton
  - question: In practice, which of the following holidays has been the most consistently romantic for you?
    answers:
      - New Year's Eve
      - Christmas Day
      - Valentine's Day
      - Mother's Day/Father's Day
  - question: What percentage of marriages do you think end in divorce or separation?
    answers:
      - 20%
      - 40%
      - 60%
      - 80%
  - question: After a few dates, your new paramour seems wonderful. Which observation would most damage your opinion of them?
    answers:
      - They say grace before every meal
      - At sunset, they lay down a mat and bow towards Mecca
      - They think your mother's religious devotion is stupid
      - Part of their income comes from a televangelist organization
  - question: After a few dates, your new paramour seems wonderful. Which observation would most damage your opinion of them?
    answers:
      - They rudely shoo a pair of children begging for money on the subway
      - They live and die by stock prices, checking them multiple times a day
      - They stop in a convenience store and buy a handful of lottery tickets
      - They have nine credit cards
  - question: If someone were to decide to go on a date with you, knowing only one of the following, which would you choose?
    answers:
       - Your voice
       - Your face
       - Your resumé
       - Your social media feeds
  - question: If you had to show one of the following to a first date, which would you be least embarrassed to share?
    answers:
      - Your laundry hamper
      - Your garbage bins
      - Hidden-camera footage of you during the last 48 hours
      - The last 30 days of your internet history
  - question: In the middle of energetic lovemaking with a new partner, they suddenly go limp and appear to be breathing but unconscious. After briefly attempting to revive them, what are you most likely to do?
    answers:
      - Get dressed and leave
      - Call one of your friends or family
      - Call 911
      - Continue making love
  - question: If you had to choose on the basis of zodialogy, who would you rather date?
    answers:
      - Gemini
      - Virgo
      - Scorpio
      - Pisces
  - question: What's the most you would spend on a Christmas gift for your partner?
    answers:
      - $100 or less
      - About $500
      - About $1,000
      - $5,000 or more
  - question: Under duress, you are forced to watch a video of one of the following. Which would be least traumatic to watch?
    answers:
      - Your parents having sex
      - Your adult child having sex with their partner
      - Your spouse enjoying sex with someone else
      - Your cousins having sex with each other
  - question: How would you prefer to receive feedback on improving your sexual performance?
    answers:
      - Having your partner tell you in the moment
      - Having a frank discussion on a random evening
      - Hearing it discreetly from your partner's best friend
      - I'd rather not know at all
  - question: Ideally, I want a partner who...
    answers:
      - is mild in the streets, and wild in the sheets
      - follows my lead
      - goes toe-to-toe with me
      - makes the decisions
  - question: On a trip, you and your partner's sibling have to share a hotel room with a single bed. That night, they reveal that they usually sleep naked. How are you likely to respond?
    answers:
      - “Do whatever makes you comfortable, I don't mind.”
      - “Me too.”
      - “I don't think that's a good idea.”
      - “What happens here, stays here, right?”
  - question: While traveling abroad, you return to your hotel suite to find a member of the staff servicing the room. Before leaving, they ask if there's anything else they can do, and strike a sexually suggestive pose. How do you respond?
    answers:
      - “No thanks.”
      - “What did you have in mind?”
      - “That depends. How much is it going to cost me?”
      - “What's the name of your supervisor?”
  - question: When it comes to looks, I consider myself to be...
    answers:
      - good-looking enough to be on TV
      - good-looking, but in an unconventional way
      - ordinary
      - ugly
  - question: Your fiance gets a research opportunity in a remote area thousands of miles away. Circumstances prevent you from accompanying them. What's the longest you think you could make your long-distance relationship work?
    answers:
      - Six months or less
      - About a year
      - A few years
      - Forever
  - question: A company uses an innovative algorithm to recommend your best dating match. You know several couples who've used their service, and they're all deliriously happy. There's one catch — once you sign up to be matched, you have to remain celibate. How long would you be willing to wait to be matched?
    answers:
      - A few weeks
      - A few months
      - A few years
      - I wouldn't sign up
  - question: In the last 12 months, how many times do you think you've had sex?
    answers:
      - Zero
      - A handful
      - About once a week
      - Too often to count, baby
  - question: Which of the following do you think makes you appear most attractive?
    answers:
      - Swimwear
      - Formal wear
      - Sleepwear
      - Going au naturel
  - question: When do you consider your sexual prime?
    answers:
      - Some years ago
      - Now
      - Hopefully, in the future
  - question: When I consume adult material, I usually...
    answers:
      - read or watch everything
      - flip or skip to the good parts
  - question: When I consume adult material, I usually...
    answers:
      - like to find something new
      - go for what I already know works for me
  - question: I prefer a partner who is...
    answers:
      - impulsive
      - somewhat grounded, but given to occasional spontaneity
      - a slave to routine
  - question: What kind of sex do you find most pleasurable?
    answers:
      - penetrative sex
      - oral sex
      - masturbation
      - video or phone sex
  - question: During intermission at a play, you spot your first serious boyfriend/girlfriend in the audience. What are you most likely to do?
    answers:
      - Sit down and try to avoid them
      - Go over and catch up during intermission
      - Go over and suggest going for a meal or drink after the play
      - Make sure they see you, so you can conspicuously ignore them
  - question: If I were to start a new romantic relationship now, I would...
    answers:
      - put a lot of effort into it
      - expect the other person to accept me, without fuss
      - expect it to fail
  - question: Through an acquaintance, you are introduced to someone who wants to pay you to sleep with them for one night — no strings attached. They are sane, healthy and pleasant, but you find them physically unattractive. How much money would it take for you to accept their proposition?
    answers:
      - $1,000 or less
      - $10,000
      - $100,000 or more
      - I wouldn't do it for any amount
  - question: If there were no societal taboos around sleeping with friends, who would you most want to approach?
    answers:
      - my best friend
      - a friend from work
      - the partner of one of my friends
      - someone from my place of worship
  - question: After dating for a couple months, your new paramour has invited you to spend the night at their place. Their intention is clear — wine, music, candlelight. As they undress, you notice a rash around their private parts. What would you do?
    answers:
      - Ignore it and get busy anyway
      - Make up an excuse and try to go straight to sleep
      - Make up an excuse to leave
      - Ask them about it
  - question: At a bar, you're approached by a total fox. You have common interests, and they laugh at your jokes. Then their sibling wanders over, and they're equally dreamy. Eventually, one of them says, "Let's go back to our place and all have some fun." What are you likely to do?
    answers:
      - Politely decline the offer
      - Collect your things, and tell them to find some other fool to fleece
      - Smile, and signal to a waiter for the bill
      - Agree, but change the location to your home
  - question: The thought of posing nude for a painter...
    answers:
      - arouses me
      - terrifies me
      - gives me butterflies, but I'd overcome my fear and do it
      - depresses me
  - question: If I were to drop out of sight for a year then return, my friends would be most surprised that I...
    answers:
      - lost 30 lbs
      - gained 60lbs
      - had a nosejob
      - got a large, visible tattoo
  - question: The private sextapes of several high-profile celebrities leak onto the Internet. Whose video would you be most tempted to watch?
    answers:
      - Cristiano Ronaldo
      - Dwayne 'The Rock' Johnson
      - Jay-Z
      - None. I wouldn't want people invading my privacy, so the least I can do is avoid the videos.
  - question: The private sextapes of several high-profile celebrities leak onto the Internet. Whose video would you be most tempted to watch?
    answers:
      - Beyoncé
      - Scarlett Johansson
      - Anna Kournikova
      - None. I wouldn't want people invading my privacy, so the least I can do is avoid the videos.
  - question: From which of the following do you derive the most satisfaction?
    answers:
      - The number of sexual partners you've had
      - Your sexual stamina or appetite
      - Memories of specific sexual experiences
  - question: You and your new beau are spending the weekend at a hotel. Which of the following situations would you find least tolerable?
    answers:
      - They ask the concierge for a room with two separate beds
      - Before making love, they close the curtains and turn off all the lights, rendering the room pitch-black
      - They insist that this weekend, you can look, but you can't touch
      - During lovemaking, they scream loud enough that adjacent guests complain to the front desk
  - question: When it comes to satisfying a new sexual partner, I would probably be...
    answers:
      - confident I will make them feel good
      - unconcerned, because an awkward beginning can be improved over time
      - tormented by the prospect of disappointing them
      - focused on my own pleasure
  - question: When I expose my private parts to someone else, I am most self-conscious about...
    answers:
      - its size and shape
      - how it smells
      - my hair in that area
      - what they're going to say
  - question: If I compare my sexual activity to my sexual appetite, I currently have sex...
    answers:
      - less often than I'd like
      - more often than I'd like
      - about as often as I'd like
  - question: Wandering through a house party, you see a woman and a man having sex. The man appears to be severely intoxicated, and unaware of his surroundings. What are you likely to do?
    answers:
      - Nothing
      - Stay and watch
      - Make some noise, hoping the woman may become self-conscious and stop
      - Speak to the woman to verify that the encounter is consensual
  - question: My erotic daydreams most often involve...
    answers:
      - potential future encounters
      - reliving past experiences
  - question: How much do you think the religious environment in which you grew up affects your feelings about sex?
    answers:
      - It's probably the dominant factor
      - It's one of a number of factors that govern how I feel
      - Not at all
  - question: If you woke up twice as rich tomorrow as you are today, how do you think it would affect your sex appeal amongst your peers?
    answers:
      - It wouldn't make a difference
      - People would be impressed by my wealth, and see me as more attractive
      - People would be alienated by my wealth, and see me as less attractive
  - question: If you had to pick a sexually transmitted infection or disease to have for the rest of your life, which would it be?
    answers:
      - Herpes
      - HIV
      - Genital warts
      - Pubic lice
  - question: At a spa, you've paid for a back and leg massage. Your masseur/masseuse has magic hands, and you're feeling wonderfully warm and relaxed. At the end of your alloted 30 min, they bend closer to you and say, "If you'd like to remove the towel and turn over, I can give you the full package. No charge — it's my pleasure." How would you respond?
    answers:
      - “That's alright. This has been amazing. Thank you.”
      - “That isn't very professional. You're lucky I don't report you to management.”
      - “Okay, but what is 'the full package', exactly?”
      - By removing your towel and turning onto your back
  - question: How many new sexual partners do you realistically expect to have during the rest of your life?
    answers:
      - None
      - One
      - A handful
      - It's a big world out there
  - question: Due to medical complications, your spouse is now physically incapable of having traditional intercourse. How would you likely satisfy your sexual needs?
    answers:
      - By making love with each other in other ways
      - By myself
      - By finding other sexual partners, without their knowledge
      - By finding other sexual partners, with their knowledge and participation
  - question: You spend the evening with a recently-divorced friend whom you've known for years. As you're getting ready to leave, they pull you in for a long hug and thank you for everything. Then they kiss you on the lips. In that moment, what are you likely to do?
    answers:
      - Return the kiss, but keep it short and chaste
      - Return the kiss, and see where it goes
      - Gently pull back, and remind them how much you value their friendship
      - Recoil, and leave as soon as possible
  - question: Assuming that all of the following jobs paid similarly, and they possessed the necessary skills, which would you choose as a way for your partner to make a living?
    answers:
      - College professor
      - CIA agent
      - Congressperson
      - Commercial airline pilot
  - question: Polyamory is...
    answers:
      - divorce, with extra steps
      - a viable way for a couple to keep the flame burning
      - a more natural kind of intimacy than monogamy
      - great in theory, but more trouble than its worth in practice
  - question: Which of the following activities, if done with a partner, is most likely to lead to you being in a naughty mood that night?
    answers:
      - A day at the beach
      - An hour of racquetball
      - Trying a new recipe for dinner
      - Watching a comedy on the couch
  - question: You're out to dinner with your partner, when a stunningly beautiful person enters the restaurant. Your partner catches you staring. How are you likely to handle the situation?
    answers:
      - Apologize for being inconsiderate of your partner's feelings
      - Get your partner's opinion on the new beauty
      - Remind your partner how attractive they are
      - Ask your partner not to start an argument in public
  - question: When I get frisky with a partner, what I would consider the actual sex usually lasts...
    answers:
      - a few minutes
      - about a half hour
      - hours
  - question: A friend excitedly regales you with tales of their marathon sexual adventures with a new lover. While outwardly sharing their excitement, you are most likely to privately feel...
    answers:
      - envious
      - depressed
      - happy for them
      - furious
  - question: You and your partner agree to participate in a medical study which requires you to make love to your partner under observation, in a special room at a nearby medical facility. Which method of observation would make it most possible for you to relax?
    answers:
      - Hidden cameras and microphones
      - A huge one-way mirror with medical personnel on the other side
      - ECG electrode patches and cords attached to your chests, hands, thighs and toes
      - A nurse sitting in the room with a pen and clipboard
  - question: A friend comes to you, slightly worried. They've found a lump in their breast — maybe. Before going to a doctor and getting tests done, they want you to feel the lump as a sanity check. What do you do?
    answers:
      - Sidestep the request by encouraging them to see a doctor, and express your willingness to accompany them on the visit
      - Sidestep the request by telling them that even if they do have a lump, it is likely to be benign
      - Agree, but ask them to guide your hand directly to the lump
      - Use your hands to thoroughly check their breasts for lumps
  - question: At a San Francisco sex party, the second floor has four distinct play areas. Which one are you most interested to see?
    answers:
      - The Torture Chamber
      - Garden of Eden
      - The French Quarter
      - Hedonist Heaven
  - question: At what age do you expect to stop being sexually active?
    answers:
      - 50
      - 65
      - 80
      - 95
  - question: You and your partner have been looking forward to getting freaky all day, but your finicky two-year-old is now sound asleep in his favorite position — on the bench at the foot of your bed. What are you most likely to do?
    answers:
      - Kiss your partner goodnight
      - Make love under the sheets as quietly as you can
      - Get freaky in the living room, watching the bedroom for any movement from the little one
      - Try to relocate the kid, so you can enjoy yourselves in the bedroom
  - question: How does the reality of your sex life compare to what you imagined when you were younger?
    answers:
      - It's much richer and more varied than I imagined
      - It's a disappointment
      - It's about what I expected
  - question: Which of the following sexual aids would you be least willing to try?
    answers:
      - Erectile dysfunction pills
      - A whip
      - Hot wax
      - A butt plug
  - question: When was the last time you wrote a letter to a friend or family member by hand?
    answers:
      - In the last year
      - In the last decade
      - I've never handwritten a letter
  - question: One of the following will be made public on the Internet. Which would you find least embarrassing?
    answers:
      - An audio recording of you having an orgasm during sex
      - A picture of your naked body
      - Honest evaluations of your sexual abilities by all of your previous partners
      - The last 180 days of your internet activity, including sites accessed via anonymous and private methods
  - question: If you had to choose, which of the following untruths would you rather have people believe about you?
    answers:
      - That you're still a virgin
      - That you're in love with a prostitute
      - That you once exchanged sex for a promotion at work
      - That you take medication for a sexually transmitted disease
